import { useRouter } from 'next/router';

import { cn } from '@/utils/helper';

import SortIcon from '../../../assets/icons/icon-expand-arrow.svg';

interface ICryptoHeadButtonProps {
  columnName: string;
  sortHandler?: () => void;
  id?: string;
  sortId?: string;
  disableSorting?: boolean;
  className?: string;
  sortKey?: string;
  dirKey?: string;
  sortIconClassName?: string;
  textClassName?: string;
}

const CryptoHeadButton: React.FC<ICryptoHeadButtonProps> = ({ columnName, sortHandler, id, sortId, disableSorting = false, className, sortKey, dirKey, sortIconClassName, textClassName }) => {
  const { query } = useRouter();

  const sort = query[sortKey || 'sort'] as string;
  const dir = query[dirKey || 'dir'] as string;

  return (
    <button className={cn(`${columnName === 'Price' ? ' pl-6 lg:pl-0' : ''} flex justify-center gap-2 items-center w-max dark:!bg-transparent`, disableSorting && 'cursor-default', className ?? '')} {...(!disableSorting && { onClick: sortHandler })}>
      <span className={cn('text-sm text-coal-250 font-medium', textClassName)}>{columnName}</span>
      {!disableSorting && <SortIcon className={cn(`${sort === (sortId || id) && (dir === 'ASC' ? 'rotate-180' : 'rotate-0')}`, sortIconClassName)} />}
    </button>
  );
};

export default CryptoHeadButton;
